import { z } from "zod";
import { noAnswerSchema, type FieldDescriptor } from "./types.js";

// Sanitised HTML subset, per docs/01-PRODUCT-SPEC.md §3.2. The allow-list is enforced at render
// time by the renderer, not here — this schema only carries the authored content.
const configSchema = z.object({
  html: z.string().max(20_000).default(""),
});

export const richTextField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "rich_text",
  label: "Rich text",
  category: "layout",
  icon: "FileText",
  configSchema,
  valueSchema: () => noAnswerSchema(),
  defaultConfig: { html: "" },
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: { isLayoutOnly: true },
};
